function getUrlParameter(parameterName, urlString) {
  var search = urlString? getUrlPartsFromString(urlString).search : window.location.search;
  var match = RegExp('[?&]' + parameterName + '=([^&]*)').exec(search);
  return match && decodeURIComponent(match[1].replace(/\+/g, ' '));
}

function buildQueryString(obj) {
  var queryString = "";
  var pairs = [];
  Object.keys(obj).map((key, index) => {
    var value = obj[key];
    if (value) pairs.push(key + "=" + value);
  });
  if (pairs.length > 0) {
    queryString += "?";
    queryString += pairs.join("&");
  }
  return queryString;
}

export {
  getUrlParameter,
  buildQueryString
};

function getUrlPartsFromString(urlString) {
  var a = document.createElement('a');
  a.href=urlString;
  return {
    host: a.host,
    hostname: a.hostname,
    pathname: a.pathname,
    protocol: a.protocol,
    search: a.search
  };
}



// WEBPACK FOOTER //
// ./../../Deploy/PWS/Scripts/tools.js